'use strict'

import Api from '@/api/invitation.js'

const state = {
  loading: true,
  error: null,
  invitation: null,
  lastSaveTimestamp: null,
  lastUpdateTimestamp: null
}

const actions = {
  fetch ({ commit }, { vacancyId }) {
    if (!vacancyId) {
      throw new Error('Empty vacancy id')
    }

    commit('fetch')

    Api.fetch(vacancyId)
      .then(data => commit('fetchSuccess', data))
      .catch(err => commit('fetchFailure', err))
  },

  save ({ commit, dispatch, state }, { vacancyId }) {
    if (!vacancyId) {
      throw new Error('Empty vacancy id')
    }

    commit('save')

    const data = state.invitation ? [ state.invitation ] : null

    return Api.save({ vacancyId, templates: data })
      .then(data => commit('saveSuccess', data))
      .catch(err => {
        commit('saveFailure', err);
        throw err;
      })
  }
}

const mutations = {
  fetch (state) {
    state.invitation = null
    state.loading = true
  },

  fetchSuccess (state, data) {
    state.invitation = data
    state.loading = false
  },

  fetchFailure (state, err) {
    state.error = err
    state.loading = false
  },

  save (state) {
    state.loading = true
  },

  saveSuccess (state, data) {
    state.invitation = data
    state.lastSaveTimestamp = new Date()
  },

  saveFailure (state, err) {
    state.loading = false
    state.error = err
    console.error(err)
  },

  update (state, data) {
    state.invitation = {
      ...state.invitation,
      ...data
    }
    state.lastUpdateTimestamp = new Date()
  },

  resetChangesTimestamps (state) {
    state.lastSaveTimestamp = null
    state.lastUpdateTimestamp = null
  }
}

const getters = {
  error (state, getters) {
    return state.error
  },

  loading (state, getters) {
    return state.loading
  },

  one (state, getters) {
    return state.invitation || {}
  },

  haveUnsavedChanges (state) {
    return state.lastUpdateTimestamp > state.lastSaveTimestamp
  },

  template_text(state, getters) {
    if(state.invitation && state.invitation.template_text) {
      return state.invitation.template_text;
    }
  },
  registration_template_text(state, getters) {
    if(state.invitation && state.invitation.registration_template_text) {
      return state.invitation.registration_template_text;
    }
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
